'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ../es-errors/syntax.js
// module id = 678
// module chunks = 0